<template>
  <div class="rs-searchresults__vue__grid">
    <RSSearchResultsCard
      v-for="(item, i) in fetchedResults.posts"
      :key="item.hash"
      :fetchedItem="item"
      ref="card"
      @hook:mounted="
        i == fetchedResults.posts.length - 1 && onBottomCardMounted()
      "
    />
  </div>
</template>

<script>
import RSSearchResultsCard from "./RSSearchResultsCard.vue";
export default {
  components: {
    RSSearchResultsCard,
  },
  props: {
    fetchedResults: Object,
  },
  methods: {
    onBottomCardMounted() {
      if (this.$refs.card && this.$refs.card.length) {
        let bottomCardVueComponent = this.$refs.card[this.$refs.card.length - 1];
        this.$emit('bottom-card-change', bottomCardVueComponent);
      }
    },
  },
};
</script>
